export default "__VITE_IMAGE_ASSET__01c7c31d__";